import {
    Component,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {ItemOrderHistory} from 'app/buffer-graph/models/item-order-history/item-order-history';
import {ItemOrderHistoryFresh} from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column'
import {OnDropdownFilteredEventArgs} from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import {DropdownFilterType} from 'app/slick-grid/interfaces/dropdown-filter-type';
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {TabComponentBase} from 'app/buffer-graph/models/tab-component-base';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {CustomFunctionReturn} from "../../../slick-grid/models/custom-function-return";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type ExportData = { columns: { header: string, field: string }[], mainRows: any[], treeRows: any[], metaData: string[] };

@Component({
    selector: 'item-order-history',
    templateUrl: './item-order-history.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css',  './item-order-history.component.css']
})
export class ItemOrderHistoryComponent extends TabComponentBase<History, ExportData>{//implements OnInit/*, AfterViewChecked*/, OnDestroy {
    constructor(graphService: BufferGraphService, exchangeService: BufferGraphDataExchangeService, translateService: TranslateService, renderer: Renderer2, elementRef: ElementRef){
        super(graphService, exchangeService, translateService, renderer, elementRef);

        this.showAllData = new EventEmitter<void>();

        this.options = {syncColumnCellResize: true, multiColumnSort: true, editable: false};
        this.dataView = new Slick.Data.DataView<History>({inlineFilters: false});
        this.dataView.onRowsChanged.subscribe(() => this.setCellCssStyles());
        this.generateColumns = true;
        this.translateService.get(['ItemOrderHistory', 'CwhOrders']).subscribe(t =>{
            this.mainRowsSheetName = t['ItemOrderHistory'],
            this.treeRowsSheetName = t['CwhOrders']
        })
    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    protected isActive: boolean;

    private isFresh: boolean;

    @Input()
    private set fresh(value: boolean){
        if (this.isFresh === value && this.isFresh != null)
            return;

        this.isFresh = value;
        //this.setColumns();
    }

    @Input()
    private allShown: boolean;

    private data: History[];

    @Input()
    private set orders(orders: History[]){
        this.data = orders;
        //setTimeout(() => {
        this.dropdownFilters = [];

        this.dataView.beginUpdate();
        this.dataView.setItems(this.getLinearDataTree(orders));
        //this.dataView.setFilter(o => this.filterOrder(o));
        this.dataView.endUpdate();
        this.gridRef.resizeGrid();
        //this.setCellCssStyles();


        // console.log(this.columns, ' set orders')
        if (this.columns && this.gridRef){
            // this.gridRef.setColumns(this.columns)
            //    this.setColumns();
        }

        //},
//            10);
    }

    @Input()
    private showCodes: boolean;


    @Input()
    protected canSend: boolean;

    @Input()
    protected columnSettings: ColumnSettingsBase[];

    @Output()
    private readonly showAllData: EventEmitter<void>;

    private readonly statusFulfillmentStylesKey = 'status-fulfillment';

    private cellCssStyles: { [key: string]: Slick.CellCssStylesHash };

    private dropdownFilters: OnDropdownFilteredEventArgs<History>[];

    //# add custom formatter for display tree model if item is PBL good (add display hide button)
    protected addCustomFormatter = (columnSettings: ColumnSettingsBase[], columns: ISlickGridColumn<History>[]): void =>{
        let hasCrossDock = (this.dataView.getItems() || []).some(o => o.crossDock != null);

        const formatValue = (r: any, c: any, v: any, col: any, order: any, formatter?: Slick.Formatter<any>): string =>{
            let toggler = '';
            if (c === 0 && hasCrossDock){
                toggler = `<span class="toggle fa fa-fw ${order.crossDock == null ? '' : order.crossDock.visible ? 'fa-minus-square-o' : 'fa-plus-square-o'} mr-1"></span>`;
            }
            return formatter ? `${toggler}${formatter(r, c, v, col, order)}` : `${toggler}${v === null ? '' : v}`;
        };


        columns.forEach(item =>{
            let formatter = item.formatter ? item.formatter : null;
            item.formatter = item.formatter ? (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => formatter(r, c, v, col, o)) : (row, cell, val, col, o) => formatValue(row, cell, val, col, o, null);
            // item.formatter = (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => formatter(r, c, v, col, o));
        })
    }

    //# generate line data for grid
    private getLinearDataTree = (orders: History[]): History[] =>{
        const array: History[] = [];
        orders.forEach(o =>{
            array.push(o);
            if (o.crossDock)
                array.push(o.crossDock);
        });
        // console.log(array, 'getLinearDataTree');
        return array;

    }

    //# set styles for grid cells
    private setCellCssStyles = (): void =>{
        let styles: Slick.CellCssStylesHash = null;
        this.dataView.getItems().forEach(o =>{
            const row = this.dataView.getRowById(o.id);
            if (row == null)
                return;

            let statusClass: string = this.helper.getClass(o.statusDescStyle),
            fulfillmentClass: string = this.helper.getClass(o.fulfillmentDescStyle);

            if (!statusClass && !fulfillmentClass)
                return;

            if (styles == null)
                styles = {};

            styles[row] = {};
            if (statusClass != null)
                styles[row]['statusDesc'] = statusClass;
            if (fulfillmentClass != null)
                styles[row]['fulfillmentDesc'] = fulfillmentClass;
        });

        this.cellCssStyles = {};
        if (styles !== null){
            this.cellCssStyles[this.statusFulfillmentStylesKey] = styles;
        }
    }

    //# no use
    /*private filterOrder = (order: History): boolean =>{

        if (order.isCwhOrder)
            return order.visible && !order.hiddenByFilter;

        for (const filter of this.dropdownFilters){
            const value = order[filter.column.field];

            let result: boolean;

            switch (filter.type){
                case DropdownFilterType.Blank:
                    result = value == null || value === '';
                    break;
                case DropdownFilterType.NonBlank:
                    result = value != null && value !== '';
                    break;
                case DropdownFilterType.ByValue:
                    result = moment.isMoment(filter.value) ? filter.value.isSame(value) : filter.value === value;
                    break;
                default:
                    result = true;
            }

            if (result)
                continue;

            if (order.crossDock != null)
                order.crossDock.hiddenByFilter = true;

            return false;
        }

        if (order.crossDock != null)
            order.crossDock.hiddenByFilter = false;

        return true;
    }*/

    //# set filter and add custom functions to filter
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }

        console.log('setFilter work')

        this.gridRef.filterHelper.startFilter = (order: any): CustomFunctionReturn => {
            if (order.isCwhOrder)
                return new CustomFunctionReturn(true, order.visible && !order.hiddenByFilter);
        };

        this.gridRef.filterHelper.endLoopFilterChange = (order: any): CustomFunctionReturn => {
            if (order.crossDock != null)
                order.crossDock.hiddenByFilter = true;
                return new CustomFunctionReturn(false, false);
        };

        this.gridRef.filterHelper.endFilterChange = (order: any): CustomFunctionReturn => {
            if (order.crossDock != null)
                order.crossDock.hiddenByFilter = false;
            return new CustomFunctionReturn(false, false);
        };

        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));
    }

    //# show all data (not use now)
    private onShowAllClick = (): void =>{
        if (this.allShown)
            return;

        this.showAllData.emit();
    }

    //# expand or collapse row in grid if item is PBL
    private onGridClick = (args: EventArgs<Slick.OnClickEventArgs<History>>): void =>{
        args.event.stopPropagation();

        if (args.data.cell !== 0)
            return;
        const target = (args.event as UIEvent).target;
        if (!(target instanceof HTMLElement) || !(target as HTMLElement).classList.contains('toggle'))
            return;

        const order = this.dataView.getItem(args.data.row);
        if (order.crossDock == null)
            return;
        order.crossDock.visible = !order.crossDock.visible;
        this.dataView.updateItem(order.id, order);
    }

    //# custom generate data for export in excel
    protected getExportData = (): ExportData => {
        const columns = this.gridRef.getColumns().map(c =>{
            return {header: c.name, field: c.field};
        })

        let mainRows = [],
            treeRows = [],
            metaData: string[] = [];

        /*const pushToRow = (val: any, array: any[]): void =>{
            if (moment.isMoment(val))
                array.push(val.toJSON());
            else if (moment.isDuration(val))
                array.push(moment(val.asMilliseconds()).toJSON());
            else
                array.push(`${val == null ? '' : val}`);
        };*/

        const saveRow = (row: any, val: any, prop: string, convRow: any): void =>{

            if (moment.isMoment(val)){
                convRow[prop]  = val.toJSON();
            } else if (moment.isDuration(val)){
                convRow[prop] = moment(val.asMilliseconds()).toJSON();
            } else{
                convRow[prop] = `${val == null ? '' : val}`;
            }
        };

        /*const updateProps = (row: any): void => {
            row.statusDescStyle = row.status;
            delete row.status;
            row.fulfillmentDescStyle = row.fulfillment;
            delete row.fulfillment;
        }*/

        const length = this.dataView.getLength();
        for (let i = 0; i < length; i++){
            const order = this.dataView.getItem(i);
            // const order2 = this.dataView.getItem(i);
            // console.log(order, 'order')
            // console.log(order2, 'order2')

            if (order.isCwhOrder)
                continue;

            const mainRow: any = {};
            const treeRow: any = order.crossDock ? {} : null;

            for (let prop in order){
                let found = prop.match(/[\w\-]+Style/);
                if (found){
                    metaData.push(prop);
                    saveRow(order, order[prop], prop, mainRow);
                    if (treeRow){
                        saveRow(order.crossDock, order.crossDock[prop], prop, treeRow);
                    }
                }
            }
            columns.forEach(c =>{
                saveRow(order, order[c.field], c.field, mainRow);
                if (treeRow){
                    saveRow(order.crossDock, order.crossDock[c.field], c.field, treeRow);
                }
            });

            mainRows.push(mainRow);

            if (treeRow){
                treeRows.push(treeRow);
            }
        }

        metaData = this.helper.checkUniqueByObj(metaData);

        // console.log(mainRows, 'mainRows')
        // console.log(cwhRows, 'cwhRows')
        // console.log(metaData, 'metaData')

        !mainRows.length ? mainRows = null : null;
        !treeRows.length ? treeRows = null : null;

        return {columns, mainRows, treeRows, metaData};
    }

    //# download excel
    private onDownloadClick = (): void =>{
        const fileName = `ItemOrderHistory_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.graphService.downloadItemOrderHistory(data.columns, data.mainRows, data.treeRows, data.metaData,  moment.locale(), this.mainRowsSheetName, this.treeRowsSheetName).map(file =>{
            return {fileContent: file, fileName};
        }));
    }

    //# send excel to email
    private onSendClick = (): void =>{
        this.sendToEmail(data => this.graphService.sendItemOrderHistory(this.tab.itemInfo.sku, this.tab.itemInfo.warehouseCode, data.columns, data.mainRows, data.treeRows, data.metaData, moment.locale(), this.mainRowsSheetName, this.treeRowsSheetName));
    }

    //# add custom sorter for grid
    private onGridSort = (args: EventArgs<Slick.OnSortEventArgs<History>>): void =>{
        const sorter = new DataSorter<History>();
        const sort: (a: History, b: History) => number = args.data.multiColumnSort
            ? (a, b) => sorter.multiColumnSorter(a, b, args.data.sortCols)
            : (a, b) => sorter.sorter(a, b, args.data.sortCol, args.data.sortAsc);
        this.data.sort(sort);
        this.dataView.setItems(this.getLinearDataTree(this.data));
    }

    public onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<History>>): void =>{
        // this.gridRef.filterHelper.onGridFiltered(args);
        // this.dataView.refresh();
    }

    public removeSort = (): void => {
        this.data.sort((a: any, b: any) => {
            return a['id'] - b['id'];
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/item-order-history.component/item-order-history.component.ts